import { Header16, Header24, Header32, Header40, Paragraph16 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { HeroBackground, HeroContent, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/about-hero.jpg'
import { Contact } from '../sections/Contact'
import whiteLine from '../assets/images/vertical-line.png'
import profileImage from '../assets/images/about-portrait.png'
import jarodImage from '../assets/images/jarod.jpg'
import jasonImage from '../assets/images/jason.jpg'
import {
    Background,
    MainContainer,
    ProfileContainer,
    ProfileContainer2,
    ProfileImageWrapper,
    TextContainer,
} from '../components/about'
import { useEffect } from 'react'

export function About() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <HeroContent>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>About Us</Header40>
                    </HeroContent>
                </HeroMainHeader>
                <ImageWrapper src={heroImage} />
            </HeroBackground>

            <Background>
                <MainContainer>
                    <ProfileContainer>
                        <TextContainer>
                            <h1>Founder</h1>
                            <h2>Jason Bartley</h2>
                            <h3>
                                Jason is a Red Seal certified carpenter with over 20 years of hands-on experience in all
                                areas of construction, from new builds to large-scale renovations. After many years in
                                the industry, he and his wife settled in Port Alberni, where they are proud to be part
                                of the community. When he is not on the job site, Jason enjoys hiking with his dogs and
                                spending time on the golf course.{' '}
                            </h3>
                        </TextContainer>
                        <ProfileImageWrapper src={jasonImage} />
                    </ProfileContainer>
                </MainContainer>
            </Background>

            <Testimonials />
            <Contact />
            <Footer />
        </div>
    )
}
